import { useIntl } from "react-intl"

import _ from "lodash"

/**
 * Basic verifier to check if object is a valid Intl object that could be formatted by react-intl API.
 * @param intlMsgDesc
 * @returns {boolean|*}
 */
export const isIntlObject = (intlMsgDesc) => {
  return _.isObject(intlMsgDesc) && intlMsgDesc.id && intlMsgDesc.defaultMessage
}

export default function useSmartFormat() {
  const { formatMessage: format } = useIntl()

  return (args, values = undefined) => {
    if (_.isNull(args) || _.isUndefined(args)) {
      return null
    }

    if (isIntlObject(args)) {
      return format(args, values)
    }

    if (_.isString(args)) {
      return args
    }

    const { intlMsgDesc } = args
    if (isIntlObject(intlMsgDesc)) {
      return format(intlMsgDesc, values)
    }
    if (intlMsgDesc) {
      return intlMsgDesc
    }

    const { orDefaultMsg } = args
    if (orDefaultMsg) {
      return format(orDefaultMsg, values)
    }

    return ""
  }
}
